
<div class="js-remove" on:click></div>

<style>
    .js-remove {
        cursor: pointer;
        border-radius: 50%;
        position: absolute;
        top: -5px;
        right: -5px;
        height: 16px;
        width: 16px;
        min-width: 16px;
        display: flex;
        justify-content: center;
        align-items: center;

        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='15.038' height='15.038' viewBox='0 0 15.038 15.038'%3E%3Cg id='Icon_feather-plus-circle' data-name='Icon feather-plus-circle' transform='translate(-2.5 -2.5)'%3E%3Cpath id='Path_1' data-name='Path 1' d='M17.038,10.019A7.019,7.019,0,1,1,10.019,3,7.019,7.019,0,0,1,17.038,10.019Z' fill='%23fff' stroke='%23cb0936' stroke-linecap='round' stroke-linejoin='round' stroke-width='1'/%3E%3Cpath id='Path_2' data-name='Path 2' d='M18,12v5.615' transform='translate(-7.981 -4.788)' fill='none' stroke='%23cb0936' stroke-linecap='round' stroke-linejoin='round' stroke-width='1'/%3E%3Cpath id='Path_3' data-name='Path 3' d='M12,18h5.615' transform='translate(-4.788 -7.981)' fill='none' stroke='%23cb0936' stroke-linecap='round' stroke-linejoin='round' stroke-width='1'/%3E%3C/g%3E%3C/svg%3E");
        transform: rotate(45deg);
        background-repeat: no-repeat;

        &:hover {
            transform: scale(1.2) rotate(45deg);
        }
    }
</style>